<template>
  <div class="animated fadeIn">
    <spot-prices/>

    <div class="row mb-3">
      <div class="col-xl-2">
        <input v-model="filters.so_number" type="text" class="form-control" placeholder="SO #">
      </div>
      <div class="col-xl-2">
        <input v-model="filters.po_number" type="text" class="form-control" placeholder="PO #">
      </div>
      <div class="col-xl-2">
        <input v-model="filters.reference" type="text" class="form-control" placeholder="Reference #">
      </div>
      <div class="col-xl-2">
        <input v-model="filters.custodian" type="text" class="form-control" placeholder="Custodian">
      </div>
      <div class="col-xl-2">
        <input v-model="filters.account_number" type="text" class="form-control" placeholder="Account #">
      </div>
      <div class="col-xl-2">
        <input v-model="filters.client_name" type="text" class="form-control" placeholder="Client Name">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-xl-2">
        <select v-model="filters.order_type" class="form-control">
          <option value="">All Types</option>
          <option value="sales">Sales Order</option>
          <option value="purchase">Purchase Order</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-xl-12">
        <button type="button" class="btn btn-primary mr-2" v-on:click="searchOrders">Search</button>
        <button type="button" class="btn btn-secondary" v-on:click="clearSearch">Clear</button>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12">
        <table class="table table-bordered table-striped table-sm table-text-no-wrap">
          <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Item</th>
            <th>Type</th>
            <th>SO #</th>
            <th>PO #</th>
            <th>Reference</th>
            <th>Custodian</th>
            <th>Account #</th>
            <th>Client Name</th>
            <th>Quantity</th>
            <th class="text-right">Price</th>
            <th class="text-right">Total</th>
            <th class="text-center">Bid</th>
            <th class="text-center">Ask</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="hasLoaded && orderHistory.length === 0">
            <td colspan="15" class="text-center">No orders found</td>
          </tr>
          <tr v-for="(item, index) in orderHistory">
            <td class="align-middle">{{item.order_created | moment('MM-DD-YYYY HH:mm')}}</td>
            <td class="align-middle">{{formatStatus(item)}}</td>
            <td class="align-middle">{{item.purchase_desc}}</td>
            <td class="align-middle">{{item.order_type}}</td>
            <td class="align-middle">{{item.so_number | formatMissing}}</td>
            <td class="align-middle">{{item.po_number | formatMissing}}</td>
            <td class="align-middle">{{displayReference(item)}}</td>
            <td class="align-middle">{{item.custodian | formatMissing}}</td>
            <td class="align-middle">{{item.account_number | formatMissing}}</td>
            <td class="align-middle">{{item.client_name | formatMissing}}</td>
            <td class="align-middle">{{item.quantity}}</td>
            <td class="align-middle text-right">{{item.rate | currency}}</td>
            <td class="align-middle text-right">{{item.total | currency}}</td>
            <td class="align-middle text-center">
              <button v-if="item.dnb" type="button" class="btn btn-primary" style="width: 140px;">
                Please Call
              </button>
              <button v-else v-on:click="sellItem(index)" type="button" class="btn btn-primary" style="width: 140px;">
                {{item.price_bid | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              </button>
            </td>
            <td class="align-middle text-center">
              <button v-if="item.dns" type="button" class="btn btn-success" style="width: 140px;">
                Please Call
              </button>
              <button v-else v-on:click="buyItem(index)" type="button" class="btn btn-success" style="width: 140px;">
                {{item.price_ask | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <announcement></announcement>
  </div>
</template>

<script>
  import { pricing } from '../../components/mixins/pricing'
  import { Announcement } from '../../components/'

  const defaultFilters = () => ({
    so_number: '',
    po_number: '',
    reference: '',
    custodian: '',
    account_number: '',
    client_name: '',
    order_type: ''
  })

  export default {
    name: 'OrderHistory',
    mixins: [pricing],
    components: {
      Announcement
    },
    data () {
      return {
        context: 'order context',
        orderHistory: [],
        currentSpot: null,
        hasLoaded: false,
        filters: defaultFilters()
      }
    },
    filters: {
      formatMissing: function (value) {
        if (!value) return '—'
        if (value === '') return '—'
        return value
      }
    },
    watch: {
      orderHistory: function (newVal, oldVal) {
        this.priceItems()
      },
      spot_prices: function (newVal, oldVal) {
        this.priceItems()
      }
    },
    methods: {
      buyItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('buy-item', this.orderHistory[index])
      },
      sellItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('sell-item', this.orderHistory[index])
      },
      buildQueryParams () {
        const params = {}
        const keys = ['so_number', 'po_number', 'reference', 'custodian', 'account_number', 'client_name', 'order_type']
        for (var i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (this.filters[key] && String(this.filters[key]).trim() !== '') {
            params[key] = String(this.filters[key]).trim()
          }
        }
        return params
      },
      getOrderHistory () {
        this.$http.get('order/history', { params: this.buildQueryParams() }).then(response => {
          this.orderHistory = response.body
          this.hasLoaded = true
        }, response => {
          console.log(response)
        })
      },
      searchOrders () {
        this.getOrderHistory()
      },
      clearSearch () {
        this.filters = defaultFilters()
        this.getOrderHistory()
      },
      formatStatus (item) {
        if (item.status_label) {
          if (item.status_label === 'submitted') return 'Submitted'
          if (item.status_label === 'failed') return 'Failed'
          return 'Pending'
        }
        if (item.status === 1) return 'Submitted'
        if (item.status === -1) return 'Failed'
        return 'Pending'
      },
      displayReference (item) {
        if (item.reference_number) {
          return item.reference_number
        }
        if (item.internal_reference) {
          return item.internal_reference
        }
        return '—'
      },
      priceItems () {
        for (var i = 0, len = this.orderHistory.length; i < len; i++) {
          const currentPrice = this.priceItem(this.currentSpot, this.orderHistory[i])
          this.orderHistory[i].price_bid = currentPrice.bid
          this.orderHistory[i].price_ask = currentPrice.ask
        }
      }
    },
    created () {
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.currentSpot = $event
          this.priceItems()
        }
      })
      this.$bus.$on('order-executed', ($event) => {
        this.getOrderHistory()
      })
    },
    beforeMount () {
      this.getOrderHistory()
      this.$bus.$emit('request-spot-price')
    }
  }
</script>

<style>
  .table-text-no-wrap td {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/orders/OrderHistory.vue